import React from "react";
import { Container, Segment, Header } from "semantic-ui-react";

class MasterColegio extends React.Component {
  render() {
    return (
      <Container fluid>
        <Segment>
          <Header as="h3" content="Master Colegios" />
        </Segment>
      </Container>
    );
  }
}

export default MasterColegio;



// WEBPACK FOOTER //
// ./src/pages/colegios/MasterColegios.jsx